module.exports = __webpack_public_path__ + "static/media/video.ef4996db.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/Pages/WhatWeveDone/BunburyCentral/video.mp4
// module id = 279
// module chunks = 0